import React from "react";
import Textfield from "../Textfield/Textfield";
import PrimaryButton from "../Buttons/PrimaryButton";
import PhoneWithIsdField from "../PhoneWithIsdField/PhoneWithIsdField";
import SingleSelectDropdown from "../Dropdown/SingleSelectDropdown";
import styles from "./SearchCard.module.scss";

const SearchCard = ({
  tabs,
  activeCard,
  setActiveCard,
  config,
  values,
  handleChange,
  setFieldValue,
  errors,
  touched,
  handleBlur,
  isLoading,
  countryMenuItems = [],
}) => {
  const getSliderPosition = () => {
    const index = tabs.findIndex((t) => t.key === activeCard);
    return index === -1 ? 0 : index;
  };
  const currentTab = tabs.find((t) => t.key === activeCard);
  const sliderClassName = [
    styles.slider,
    styles[`sliderPosition${getSliderPosition()}`],
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={styles.wrapper}>
      <div className={styles.tabHeader}>
        {tabs.map((tab) => {
          const isEnabled = config?.[tab.key];

          return (
            <div
              key={tab.key}
              className={`${styles.tabItem}
          ${activeCard === tab.key ? styles.active : ""}
          ${!isEnabled ? styles.disabled : ""}`}
              onClick={() => isEnabled && setActiveCard(tab.key)}
            >
              {tab.label}
            </div>
          );
        })}

        {activeCard && <div className={sliderClassName} />}
      </div>

      <div className={styles.content}>
        {activeCard && config?.[activeCard] && (
          <>
            {activeCard === "phone" ? (
              <PhoneWithIsdField
                id="phone"
                label={currentTab?.placeholder}
                isdCode={values.isd_code}
                phone={values.phone}
                onIsdCodeChange={(nextIsdCode) =>
                  setFieldValue("isd_code", nextIsdCode)
                }
                onPhoneChange={(nextPhone) => setFieldValue("phone", nextPhone)}
                onPhoneBlur={handleBlur}
                error={Boolean(errors?.phone || errors?.isd_code)}
                helperText={errors?.isd_code || errors?.phone || ""}
              />
            ) : (
              <Textfield
                name={activeCard}
                label={currentTab?.placeholder}
                value={values[activeCard]}
                handleOnChange={handleChange}
                onBlur={handleBlur}
                error={Boolean(errors?.[activeCard])}
                helperText={errors?.[activeCard]}
              />
            )}

            {activeCard === "uam_id" && (
              <SingleSelectDropdown
                label="Select country"
                name="country_id"
                value={values.country_id}
                onChange={handleChange}
                options={countryMenuItems}
              />
            )}

            <div className={styles.actionWrapper}>
              <PrimaryButton type="submit" isLoading={isLoading} fullWidth>
                Search User
              </PrimaryButton>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SearchCard;
